module.exports = __webpack_public_path__ + "static/media/Stellar Ora Queen Headboard - 155 cm_Black.52a1cb31.png";